
<mat-card class= "card">
  <header>
    <h3>Complete your registration</h3>
  </header>
  <form 
  style="padding-top: 5%;" 
  [formGroup]="completeRegisterForm" 
  (ngSubmit)="confirm()">
  <div>
      <input type="password" placeholder="Password" formControlName='password'>
      <input type="password" placeholder="Confirm Password" formControlName='confirmPassword'>
  </div>
  <div class="buttons">
    <button class="button"> Confirm</button>
  </div>
</form>
</mat-card>